var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlacementViews = function SvgPlacementViews(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 11.25C20.0459 11.25 22.3125 8.98344 22.3125 6.1875C22.3125 3.39156 20.0459 1.125 17.25 1.125C14.4541 1.125 12.1875 3.39156 12.1875 6.1875C12.1875 8.98344 14.4541 11.25 17.25 11.25Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3294 15.75C21.6654 14.2385 19.4979 13.4011 17.2499 13.4011C15.0019 13.4011 12.8345 14.2385 11.1704 15.75",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3124 6.35399C21.3982 6.61744 20.4514 6.75075 19.4999 6.74999C16.9611 6.75377 14.5142 5.79977 12.6479 4.07849",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 29.25C30.5459 29.25 32.8125 26.9834 32.8125 24.1875C32.8125 21.3916 30.5459 19.125 27.75 19.125C24.9541 19.125 22.6875 21.3916 22.6875 24.1875C22.6875 26.9834 24.9541 29.25 27.75 29.25Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 34.875C34.0297 33.7921 32.9486 32.9162 31.714 32.3138C30.4794 31.7113 29.1237 31.3982 27.75 31.3982C26.3763 31.3982 25.0206 31.7113 23.786 32.3138C22.5514 32.9162 21.4703 33.7921 20.625 34.875",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8124 24.354C31.1416 24.8351 29.3751 24.8785 27.6826 24.48C25.9902 24.0816 24.4286 23.2546 23.1479 22.0785",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 29.25C11.0459 29.25 13.3125 26.9834 13.3125 24.1875C13.3125 21.3916 11.0459 19.125 8.25 19.125C5.45406 19.125 3.1875 21.3916 3.1875 24.1875C3.1875 26.9834 5.45406 29.25 8.25 29.25Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3735 34.875C14.5282 33.7921 13.4472 32.9162 12.2126 32.3138C10.978 31.7113 9.62228 31.3982 8.24853 31.3982C6.87479 31.3982 5.51911 31.7113 4.28451 32.3138C3.04991 32.9162 1.96888 33.7921 1.12354 34.875",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3124 24.354C11.6416 24.8351 9.8751 24.8785 8.18264 24.48C6.49017 24.0816 4.92861 23.2546 3.64795 22.0785",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlacementViews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placement-views.55827964.svg";
export { ForwardRef as ReactComponent };